//LOCAL CONFIG
//export const VUE_APP_API_URL = "http://136.144.245.143:1234/";
//export const VUE_APP_API_URL = "https://136.144.245.143:8443/";
export const VUE_APP_API_URL = "https://ccib-ahilido.bj/api/";
//export const VUE_APP_API_URL = "https://ahilido.cci.bj/";
//export const VUE_APP_API_URL = "http://85.234.130.239:1234";
export const VUE_APP_BASE_URL = "/admin";
export const COOKIES_EXPIRE = "60MIN";


